import { Role } from "../../../api/models/fraud.models";

export interface Profile {
    /** `USER-<id>`; the same id appears as `ACCOUNT-<id>` on admin rows (AML-1056). */
    uuid: string;
    accountId: number;
    email: string;
    isPassed: boolean;
    phone: string;
    sessionExpiresIn: number;
    token: string;
    username: string;
    role: Role;
}

export interface AuthStepResponse {
    code_length: number;
    code_lifetime: number;
    key: string;
    next: AuthSteps;
    mask: string;
}

export enum TypeVerifiedRegister {
    phone = 'phone',
    email = 'email',
    totp = 'totp',
}

export enum AuthSteps {
    PHONE = 'PHONE',
    EMAIL = 'EMAIL',
    PHONE_CODE = 'PHONE_CODE',
    EMAIL_CODE = 'EMAIL_CODE',
    TWO_FACTOR = 'TWO_FACTOR',
    LOGIN = 'LOGIN',
}

// Request-only step to re-send the email code (backend replies with next = EMAIL_CODE again).
export const EMAIL_RESEND_STEP = 'EMAIL_RESEND';

